<script lang="ts" setup>
import {
  Contexts,
  getContainer,
  NamedBindings,
  TranslationService,
} from '@dandelion/core';
import { PropType, ref, Ref } from 'vue';
import { PreferenceValueConfig } from '../../entities/Preference';

const props = defineProps({
  title: {
    type: String,
    required: true,
  },
  options: {
    type: Object as PropType<Record<string, PreferenceValueConfig>>,
    required: true,
  },
  selectedOption: {
    type: Object as PropType<Ref<String>>,
    required: true,
  },
});

const sharedContainer = getContainer(Contexts.SHARED);
const ts = sharedContainer.get(
  NamedBindings.TranslationService
) as TranslationService;

const emit = defineEmits(['back-to-preferences', 'close', 'value-selected']);

const mySelection = ref(props.selectedOption.value);
</script>

<template>
  <header>
    <ion-icon
      name="chevron-back-outline"
      @click="emit('back-to-preferences')"
    ></ion-icon>
    <h2 v-html="ts.t(props.title)"></h2>
    <ion-icon
      name="close-outline"
      @click="emit('close')"
    ></ion-icon>
  </header>
  <main>
    <div
      v-for="option in options"
      class="preferences-dialog-card"
    >
      <div
        :class="{
          'preferences-dialog-icon-wrapper': true,
          'icon-active': mySelection == option.value,
        }"
        @click="mySelection = option.value"
      >
        <span :class="option.icon"></span>
        <ion-icon :name="option.icon"></ion-icon>
      </div>
      <p
        class="preferences-dialog-description"
        v-html="ts.t(option.description)"
      ></p>
    </div>
  </main>
  <footer>
    <button
      type="button"
      @click="emit('value-selected', mySelection)"
      v-html="ts.t('Confirm')"
    ></button>
  </footer>
</template>
